/**
 * @generated SignedSource<<93fda949a7d380e22ba4ae392c5cb2b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableHierarchyToggle_HierarchyToggle$data = {
  readonly __id: string;
  readonly id: string;
  readonly isHierarchyEnabled: boolean | null | undefined;
  readonly viewId: string | null | undefined;
  readonly " $fragmentType": "ui_issueTableHierarchyToggle_HierarchyToggle";
};
export type ui_issueTableHierarchyToggle_HierarchyToggle$key = {
  readonly " $data"?: ui_issueTableHierarchyToggle_HierarchyToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHierarchyToggle_HierarchyToggle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueTableHierarchyToggle_HierarchyToggle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "viewId"
    },
    {
      "kind": "ScalarField",
      "name": "isHierarchyEnabled"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "c145cbe66a3dd68e43910a10f4d137da";

export default node;
